// extracted by mini-css-extract-plugin
export default {"flex-column":"postContent_flex-column__gTjAl","content":"postContent_content__XTBVa","flex-row":"postContent_flex-row__djn6I","page-size":"postContent_page-size__GhaCu"};